module.exports = __webpack_public_path__ + "static/media/weixin.33c3e06.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/weixin.mp3
// module id = b+yy
// module chunks = 208